import { render, staticRenderFns } from "./SelectedCategoriesBubble.vue?vue&type=template&id=97334030&scoped=true"
import script from "./SelectedCategoriesBubble.vue?vue&type=script&lang=js"
export * from "./SelectedCategoriesBubble.vue?vue&type=script&lang=js"
import style0 from "./SelectedCategoriesBubble.vue?vue&type=style&index=0&id=97334030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97334030",
  null
  
)

export default component.exports